import React from 'react';
import { classNames } from '../tools/helpers';

export default function Logo({ children, className }) {
    return (
        <h1
            className={classNames(
                '!m-0 font-bold leading-8 text-[24px] text-white',
                className,
            )}
        >
            Visa
            <span className={'font-normal'}>Eropa</span>
            {children}
        </h1>
    );
}
